const configs = {
  ...window.env
};

//Created getter to mock calls for unit testing
export const get = (configurationName) => {
  return configs[configurationName]
}

export default configs;